module.exports = __webpack_public_path__ + "static/media/om_beard_tailored_long__square_shadow.6518a5e1.png";